export default function NotFound() {
  return (
    <div className="h-full flex flex-col justify-center gap-2 text-center">
      <h1 className="text-7xl font-bold text-red-600">404</h1>
      <p className="text-2xl mt-2">Halaman tidak ditemukan</p>
    </div>
  )
}
